// components/Services.js
import React from 'react';
import SectionTitle from './SectionTitle';
import ServiceCard from './ServiceCard';
import { FiSun, FiBattery, FiHome, FiBriefcase, FiSettings, FiCheck } from 'react-icons/fi';

const Services = () => {
  const services = [
    {
      id: 1,
      title: "Residential Solar Systems",
      description: "Complete solar solutions for homes with grid-tied, off-grid, and hybrid options.",
      icon: <FiHome />,
      link: "/services/residential"
    },
    {
      id: 2,
      title: "Commercial Solar PV",
      description: "Reduce energy costs and grid dependency with our custom commercial installations.",
      icon: <FiBriefcase />,
      link: "/services/commercial"
    },
    {
      id: 3,
      title: "Backup Power Systems",
      description: "Keep your home or business running during outages with reliable backup power.",
      icon: <FiBattery />,
      link: "/services/backup"
    },
    {
      id: 4,
      title: "Off-Grid Solutions",
      description: "Complete energy independence with our custom off-grid power systems.",
      icon: <FiSun />,
      link: "/services/off-grid"
    },
    {
      id: 5,
      title: "Consultancy Services",
      description: "Expert load evaluation, system sizing, and design for optimal performance.",
      icon: <FiSettings />,
      link: "/services/consultancy"
    },
    {
      id: 6,
      title: "After-Sales Support",
      description: "Remote monitoring, emergency response, and scheduled maintenance visits.",
      icon: <FiCheck />,
      link: "/services/support"
    }
  ];

  return (
    <section id="services" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <SectionTitle 
          title="Our Services" 
          subtitle="Comprehensive solar solutions for every need"
          centered={true}
        />
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <ServiceCard 
              key={service.id}
              title={service.title}
              description={service.description}
              icon={service.icon}
              link={service.link}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;